var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _buyButtonsIntersectionObserver, _mainBottomObserver, _resetTimeout, _isStuck, _animationTimeout, _abortController, _targetAddToCartButton, _currentQuantity, _hiddenByBottom, _StickyAddToCartComponent_instances, setupIntersectionObserver_fn, _handleProductSelect, _handleVariantUnavailable, _handleCartAddComplete, _handleQuantityUpdate, showStickyBar_fn, hideStickyBar_fn, isChatActive_fn, getProductForm_fn, getInitialQuantity_fn, updateButtonText_fn;
import { Component } from "@theme/component";
import { ThemeEvents, QuantitySelectorUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";
import { onAnimationEnd } from "@theme/utilities";
import { StandardEvents, ProductSelectEvent, CartLinesUpdateEvent, CartErrorEvent } from "@shopify/events";
class StickyAddToCartComponent extends Component {
  constructor() {
    super(...arguments);
    this.selectionGeneration = 0;
    this.selectionDetached = false;
    this.variantSelectionPending = false;
    __privateAdd(this, _StickyAddToCartComponent_instances);
    __publicField(this, "requiredRefs", ["stickyBar", "addToCartButton", "quantityDisplay", "quantityNumber"]);
    __privateAdd(this, _buyButtonsIntersectionObserver, null);
    __privateAdd(this, _mainBottomObserver, null);
    __privateAdd(this, _resetTimeout);
    __privateAdd(this, _isStuck, false);
    __privateAdd(this, _animationTimeout, null);
    __privateAdd(this, _abortController, new AbortController());
    __privateAdd(this, _targetAddToCartButton, null);
    __privateAdd(this, _currentQuantity, 1);
    __privateAdd(this, _hiddenByBottom, false);
    __publicField(this, "handleAddToCartClick", async () => {
      if (this.selectionDetached || this.variantSelectionPending || this.refs.addToCartButton.disabled || !__privateGet(this, _targetAddToCartButton) || __privateGet(this, _targetAddToCartButton).disabled) return;
      __privateGet(this, _targetAddToCartButton).dataset.puppet = "true";
      __privateGet(this, _targetAddToCartButton).click();
      const cartIcon = document.querySelector(".header-actions__cart-icon");
      if (this.refs.addToCartButton.dataset.added !== "true") {
        this.refs.addToCartButton.dataset.added = "true";
      }
      if (!cartIcon || !this.refs.addToCartButton || !this.refs.productImage) return;
      if (__privateGet(this, _resetTimeout)) clearTimeout(__privateGet(this, _resetTimeout));
      const flyToCartElement = (
        /** @type {FlyToCart} */
        document.createElement("fly-to-cart")
      );
      const sourceStyles = getComputedStyle(this.refs.productImage);
      flyToCartElement.classList.add("fly-to-cart--sticky");
      flyToCartElement.style.setProperty("background-image", "url(".concat(this.refs.productImage.src, ")"));
      flyToCartElement.useSourceSize = "true";
      flyToCartElement.source = this.refs.productImage;
      flyToCartElement.destination = cartIcon;
      document.body.appendChild(flyToCartElement);
      const generation = this.selectionGeneration;
      await onAnimationEnd([this.refs.addToCartButton, flyToCartElement]);
      if (this.selectionDetached || generation !== this.selectionGeneration) return;
      __privateSet(this, _resetTimeout, setTimeout(() => {
        this.refs.addToCartButton.removeAttribute("data-added");
      }, 800));
    });
    __privateAdd(this, _handleProductSelect, (event) => {
      var _a2;
      var _a;
      if (!(event.target instanceof Element) || event.target.closest("product-card")) return;
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      if (((_a2 = event.product) == null ? void 0 : _a2.id) && this.dataset.productId && String(event.product.id) !== String(this.dataset.productId)) return;
      const generation = ++this.selectionGeneration;
      const previousDisabled = this.refs.addToCartButton.disabled;
      this.variantSelectionPending = true;
      this.refs.addToCartButton.disabled = true;
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        if (!(detail == null ? void 0 : detail.html)) throw new Error("Variant response missing");
        const { html, productId, resource: variant } = detail;
        if (detail.newProduct) this.dataset.productId = detail.newProduct.id;
        else if (productId && String(productId) !== String(this.dataset.productId)) {
          this.variantSelectionPending = false;
          this.refs.addToCartButton.disabled = previousDisabled;
          return;
        }
        const newStickyAddToCart = (
          /** @type {HTMLElement | null} */
          html.querySelector("sticky-add-to-cart")
        );
        if (!newStickyAddToCart) throw new Error("Sticky variant response missing");
        const newStickyBar = newStickyAddToCart.querySelector('[ref="stickyBar"]');
        if (!newStickyBar) throw new Error("Sticky content missing");
        const currentStuck = this.refs.stickyBar.getAttribute("data-stuck") || "false";
        const variantAvailable = newStickyAddToCart.dataset.variantAvailable;
        morph(this.refs.stickyBar, newStickyBar, { childrenOnly: true });
        this.refs.stickyBar.setAttribute("data-stuck", currentStuck);
        this.dataset.variantAvailable = variantAvailable;
        this.variantSelectionPending = false;
        const returnedButton = newStickyBar.querySelector('[ref="addToCartButton"]');
        this.refs.addToCartButton.disabled = !variant || variant.available === false || variantAvailable === "false" || Boolean(returnedButton == null ? void 0 : returnedButton.disabled);
        if (variant && variant.id) {
          this.dataset.currentVariantId = variant.id;
        }
        const productForm = __privateMethod(this, _StickyAddToCartComponent_instances, getProductForm_fn).call(this);
        if (productForm) {
          __privateSet(this, _targetAddToCartButton, productForm.querySelector('[ref="addToCartButton"]'));
        }
        if (variant == null) {
          __privateGet(this, _handleVariantUnavailable).call(this);
        }
        __privateMethod(this, _StickyAddToCartComponent_instances, updateButtonText_fn).call(this);
      }).catch((error) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        this.variantSelectionPending = false;
        this.refs.addToCartButton.disabled = true;
        this.dataset.currentVariantId = "";
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[sticky-add-to-cart] Event promise rejected:", error);
      });
    });
    __privateAdd(this, _handleVariantUnavailable, () => {
      this.dataset.currentVariantId = "";
      const variantTitleElement = this.querySelector(".sticky-add-to-cart__variant");
      const productId = this.dataset.productId;
      const variantPicker = document.querySelector('variant-picker[data-product-id="'.concat(productId, '"]'));
      if (!variantTitleElement || !variantPicker) return;
      const selectedOptions = Array.from(variantPicker.querySelectorAll("input:checked")).map((option) => (
        /** @type {HTMLInputElement} */
        option.value
      )).filter((value) => value !== "").join(" / ");
      if (!selectedOptions) return;
      variantTitleElement.textContent = selectedOptions;
    });
    __privateAdd(this, _handleCartAddComplete, (event) => {
      const resetPuppet = () => {
        if (__privateGet(this, _targetAddToCartButton)) {
          __privateGet(this, _targetAddToCartButton).dataset.puppet = "false";
        }
      };
      if ("promise" in event && event.promise instanceof Promise) {
        event.promise.then(resetPuppet, resetPuppet);
      } else {
        resetPuppet();
      }
    });
    __privateAdd(this, _handleQuantityUpdate, (event) => {
      if (event.detail.cartLine) return;
      __privateSet(this, _currentQuantity, event.detail.quantity);
      __privateMethod(this, _StickyAddToCartComponent_instances, updateButtonText_fn).call(this);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.selectionDetached = false;
    if (__privateGet(this, _abortController).signal.aborted) __privateSet(this, _abortController, new AbortController());
    __privateMethod(this, _StickyAddToCartComponent_instances, setupIntersectionObserver_fn).call(this);
    const { signal } = __privateGet(this, _abortController);
    const target = this.closest(".shopify-section");
    target == null ? void 0 : target.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect), { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _handleCartAddComplete), { signal });
    document.addEventListener(StandardEvents.cartError, __privateGet(this, _handleCartAddComplete), { signal });
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, __privateGet(this, _handleQuantityUpdate), { signal });
    __privateMethod(this, _StickyAddToCartComponent_instances, getInitialQuantity_fn).call(this);
    customElements.whenDefined("shopify-chat").then(() => {
      if (signal.aborted) return;
      if (__privateGet(this, _isStuck) && __privateMethod(this, _StickyAddToCartComponent_instances, isChatActive_fn).call(this)) __privateMethod(this, _StickyAddToCartComponent_instances, hideStickyBar_fn).call(this);
    });
  }
  disconnectedCallback() {
    var _a, _b;
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    clearTimeout(__privateGet(this, _resetTimeout));
    (_a = __privateGet(this, _buyButtonsIntersectionObserver)) == null ? void 0 : _a.disconnect();
    (_b = __privateGet(this, _mainBottomObserver)) == null ? void 0 : _b.disconnect();
    __privateGet(this, _abortController).abort();
    if (__privateGet(this, _animationTimeout)) {
      clearTimeout(__privateGet(this, _animationTimeout));
    }
  }
}
_buyButtonsIntersectionObserver = /* @__PURE__ */ new WeakMap();
_mainBottomObserver = /* @__PURE__ */ new WeakMap();
_resetTimeout = /* @__PURE__ */ new WeakMap();
_isStuck = /* @__PURE__ */ new WeakMap();
_animationTimeout = /* @__PURE__ */ new WeakMap();
_abortController = /* @__PURE__ */ new WeakMap();
_targetAddToCartButton = /* @__PURE__ */ new WeakMap();
_currentQuantity = /* @__PURE__ */ new WeakMap();
_hiddenByBottom = /* @__PURE__ */ new WeakMap();
_StickyAddToCartComponent_instances = /* @__PURE__ */ new WeakSet();
setupIntersectionObserver_fn = function() {
  var _a;
  const productForm = __privateMethod(this, _StickyAddToCartComponent_instances, getProductForm_fn).call(this);
  if (!productForm) return;
  const buyButtonsBlock = productForm.closest(".buy-buttons-block");
  if (!buyButtonsBlock) return;
  const footer = (_a = document.querySelector("footer")) != null ? _a : document.querySelector('[class*="footer-group"]');
  if (!footer) return;
  __privateSet(this, _buyButtonsIntersectionObserver, new IntersectionObserver((entries) => {
    const [entry] = entries;
    if (!entry) return;
    if (!entry.isIntersecting && !__privateGet(this, _isStuck)) {
      const rect = entry.target.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top < 0) {
        if (__privateMethod(this, _StickyAddToCartComponent_instances, isChatActive_fn).call(this)) return;
        __privateMethod(this, _StickyAddToCartComponent_instances, showStickyBar_fn).call(this);
      }
    } else if (entry.isIntersecting && __privateGet(this, _isStuck)) {
      __privateSet(this, _hiddenByBottom, false);
      __privateMethod(this, _StickyAddToCartComponent_instances, hideStickyBar_fn).call(this);
    }
  }));
  __privateSet(this, _mainBottomObserver, new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      if (!entry) return;
      if (entry.isIntersecting && __privateGet(this, _isStuck)) {
        __privateSet(this, _hiddenByBottom, true);
        __privateMethod(this, _StickyAddToCartComponent_instances, hideStickyBar_fn).call(this);
      } else if (!entry.isIntersecting && __privateGet(this, _hiddenByBottom)) {
        const rect = buyButtonsBlock.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top < 0) {
          __privateSet(this, _hiddenByBottom, false);
          if (!__privateMethod(this, _StickyAddToCartComponent_instances, isChatActive_fn).call(this)) {
            __privateMethod(this, _StickyAddToCartComponent_instances, showStickyBar_fn).call(this);
          }
        }
      }
    },
    {
      rootMargin: "200px 0px 0px 0px"
    }
  ));
  __privateGet(this, _buyButtonsIntersectionObserver).observe(buyButtonsBlock);
  __privateGet(this, _mainBottomObserver).observe(footer);
  __privateSet(this, _targetAddToCartButton, productForm.querySelector('[ref="addToCartButton"]'));
};
_handleProductSelect = /* @__PURE__ */ new WeakMap();
_handleVariantUnavailable = /* @__PURE__ */ new WeakMap();
_handleCartAddComplete = /* @__PURE__ */ new WeakMap();
_handleQuantityUpdate = /* @__PURE__ */ new WeakMap();
showStickyBar_fn = function() {
  const { stickyBar } = this.refs;
  __privateSet(this, _isStuck, true);
  stickyBar.dataset.stuck = "true";
};
hideStickyBar_fn = function() {
  const { stickyBar } = this.refs;
  __privateSet(this, _isStuck, false);
  stickyBar.dataset.stuck = "false";
};
isChatActive_fn = function() {
  if (!customElements.get("shopify-chat")) return false;
  return Boolean(document.querySelector("shopify-chat"));
};
getProductForm_fn = function() {
  const productId = this.dataset.productId;
  if (!productId) return null;
  const sectionElement = this.closest(".shopify-section");
  if (!sectionElement) return null;
  const sectionId = sectionElement.id.replace("shopify-section-", "");
  return document.querySelector(
    "#shopify-section-".concat(sectionId, ' product-form-component[data-product-id="').concat(productId, '"]')
  );
};
getInitialQuantity_fn = function() {
  __privateSet(this, _currentQuantity, parseInt(this.dataset.initialQuantity || "1") || 1);
  __privateMethod(this, _StickyAddToCartComponent_instances, updateButtonText_fn).call(this);
};
updateButtonText_fn = function() {
  const { addToCartButton, quantityDisplay, quantityNumber } = this.refs;
  const available = !addToCartButton.disabled;
  quantityNumber.textContent = __privateGet(this, _currentQuantity).toString();
  if (available && __privateGet(this, _currentQuantity) > 1) {
    quantityDisplay.style.display = "inline";
  } else {
    quantityDisplay.style.display = "none";
  }
};
if (!customElements.get("sticky-add-to-cart")) {
  customElements.define("sticky-add-to-cart", StickyAddToCartComponent);
}
